import { RibbonLendVault__factory } from "../codegen/factories/RibbonLendVault__factory";
export var getLendContract = function (library, pool, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var provider = useSigner ? library.getSigner() : library;
    return RibbonLendVault__factory.connect(pool, provider);
};
//# sourceMappingURL=getLendContract.js.map